import { A } from '@ember/array';
import { computed } from '@ember/object';
export default function rejectBy(collectionProperty, property, ...value) {
  return computed(`${collectionProperty}.@each.${property}`, function () {
    return (this.get(collectionProperty) || A([])).rejectBy(property, ...value);
  });
}